// config/routes.js
export const routes = {
    home: '/',
    about: '/about',
    guide: '/guide',
    blast: {
      upload: '/blast/upload',
      analysis: '/blast/analysis',
      results: '/blast/results/:jobId'
    },
    admin: {
      dashboard: '/admin/dashboard',
      genomeManager: '/admin/genomes',
      settings: '/admin/settings'
    },
    login: {
      signIn: '/login/signin',
      signOut: '/login/signout',
      register: '/login/register'
    },
    legal: {
      terms: '/terms',
      privacy: '/privacy'
    }
  };